export const updateRiskMatrixService = (fetch) => async (id, riskMatrix) => {
  try {
    const response = await fetch({
      url: '/api/v1/matriz-riesgo/' + id,
      method: 'put',
      body: riskMatrix,
    })

    return response
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
